"use client";

import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { useEffect } from "react";

let hasInitialized = false;

export default function DatadogRumInit() {
  useEffect(() => {
    if (hasInitialized) {
      return;
    }

    hasInitialized = true;

    datadogRum.init({
      applicationId: "372a469a-733a-4fc5-9076-8b2b1bece44f",
      clientToken: "pub25f809d410116ce32ec8d2fb52737eab",
      site: "ap1.datadoghq.com",
      service: "searchright.net",
      env: "prod",
      version: "1.0.0",
      sessionSampleRate: 100,
      sessionReplaySampleRate: 50,
      trackResources: true,
      trackUserInteractions: true,
      trackLongTasks: true,
      plugins: [reactPlugin({ router: false })],
    });
  }, []);

  return null;
}
